import { Card, Suit, Rank } from '../state/ArenaTypes';
import {
  CardSuit,
  TrumpSuitEnum,
  STANDARD_SUITS,
  normalizeSuit,
  toShortSuitCode,
  areSuitsEqual,
  isSpades,
  isHearts,
  isClubs,
  isDiamonds,
  isJoker,
  isNoTrump,
  isRedSuit,
  isBlackSuit,
  getSuitSymbol,
  getSuitColor,
} from './CardSuits';

export {
  CardSuit,
  TrumpSuitEnum,
  STANDARD_SUITS,
  normalizeSuit,
  toShortSuitCode,
  areSuitsEqual,
  isSpades,
  isHearts,
  isClubs,
  isDiamonds,
  isJoker,
  isNoTrump,
  isRedSuit,
  isBlackSuit,
  getSuitSymbol,
  getSuitColor,
};

export const STANDARD_RANKS: Rank[] = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];

/**
 * Creates standard 52-card deck using full suit names and compact IDs (Option 1)
 */
export function createStandardDeck(): Card[] {
  const deck: Card[] = [];
  for (const suit of STANDARD_SUITS) {
    const shortCode = toShortSuitCode(suit);
    for (const rank of STANDARD_RANKS) {
      deck.push({
        id: `${shortCode}_${rank}`,
        suit,
        rank,
        displayValue: `${rank}${getSuitSymbol(suit)}`
      });
    }
  }
  return deck;
}

const STANDARD_CARDS_BY_ID = new Map<string, Card>();

// Initialize standard 52 cards plus jokers for lookup
for (const card of createStandardDeck()) {
  STANDARD_CARDS_BY_ID.set(card.id, card);
}
STANDARD_CARDS_BY_ID.set('BJ', {
  id: 'BJ',
  suit: 'Joker',
  rank: 'BJ',
  isBigJoker: true,
  displayValue: '★ Big Joker'
});
STANDARD_CARDS_BY_ID.set('LJ', {
  id: 'LJ',
  suit: 'Joker',
  rank: 'LJ',
  isLittleJoker: true,
  displayValue: '★ Little Joker'
});

export function getCardById(id: string): Card | undefined {
  return STANDARD_CARDS_BY_ID.get(id);
}
